module.exports = __webpack_public_path__ + "img/paint.f86e9588.png";